<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="2.5" width="13" height="9" rx="1.5" stroke="#999DA6"/>
    <rect x="0.5" y="4.5" width="13" height="2" fill="#999DA6"/>
  </svg>
</template>

<script>
export default {};
</script>
